import { Root } from '@insurgrid/common';
import { BASE_PATH } from '../../../paths';

export interface SubmissionPaths {
  UPLOAD: string;
  CARRIER_INTERSTITIAL: string;
  HAS_ACCOUNT: string;
  CREATE_ACCOUNT: string;
  VALIDATE: string;
  VALIDATED: string;
  SELECT_CARRIER: string;
  ADDITIONAL_CARRIER: string;
  FETCHING: string;
  CONTINUE_EXISTING: string;
  CARRIER_UNAVAILABLE: string;
  CARRIER_CONNECTED: string;
  BEAGLE_OFFER: string;
  BEAGLE_THANKS: string;
  BEAGLE_PROPERTY_MANAGER: string;
  INTAKE_FORM: string;
}
export const SUBMISSION_ROOT_PATH = `${BASE_PATH}/${Root.Submission}`;

const CREATE_PATH = `${SUBMISSION_ROOT_PATH}/create`;
const UPDATE_PATH = `${SUBMISSION_ROOT_PATH}/[submissionId]/update`;

export const SubmissionCreatePaths: SubmissionPaths = {
  INTAKE_FORM: `${CREATE_PATH}/intake`,
  UPLOAD: `${CREATE_PATH}/[carrierSlug]/upload`,
  CARRIER_INTERSTITIAL: `${CREATE_PATH}/[carrierSlug]/carrier-interstitial`,
  VALIDATE: `${CREATE_PATH}/[carrierSlug]/validate`,
  FETCHING: `${SUBMISSION_ROOT_PATH}/fetching`,
  VALIDATED: `${CREATE_PATH}/[carrierSlug]/validated`,
  SELECT_CARRIER: `${CREATE_PATH}/select-carrier`,
  // feature flags
  HAS_ACCOUNT: `${CREATE_PATH}/[carrierSlug]/has-account`,
  CREATE_ACCOUNT: `${CREATE_PATH}/[carrierSlug]/create-account`,
  ADDITIONAL_CARRIER: `${CREATE_PATH}/additional-carrier`,
  CONTINUE_EXISTING: `${CREATE_PATH}/[carrierSlug]/continue-existing`,
  CARRIER_UNAVAILABLE: `${CREATE_PATH}/[carrierSlug]/unavailable`,
  CARRIER_CONNECTED: `${CREATE_PATH}/[carrierSlug]/connected`,
  BEAGLE_OFFER: `${SUBMISSION_ROOT_PATH}/beagle-offer`,
  BEAGLE_THANKS: `${SUBMISSION_ROOT_PATH}/beagle-thanks`,
  BEAGLE_PROPERTY_MANAGER: `${SUBMISSION_ROOT_PATH}/beagle-property-manager`,
};

export const SubmissionEditPaths: SubmissionPaths = {
  INTAKE_FORM: `${CREATE_PATH}/intake`,
  UPLOAD: `${UPDATE_PATH}/[carrierSlug]/upload`,
  CARRIER_INTERSTITIAL: `${UPDATE_PATH}/[carrierSlug]/carrier-interstitial`,
  HAS_ACCOUNT: `${UPDATE_PATH}/[carrierSlug]/has-account`,
  CREATE_ACCOUNT: `${UPDATE_PATH}/[carrierSlug]/create-account`,
  VALIDATE: `${UPDATE_PATH}/[carrierSlug]/validate`,
  VALIDATED: `${UPDATE_PATH}/[carrierSlug]/validated`,
  SELECT_CARRIER: `${UPDATE_PATH}/select-carrier`,
  ADDITIONAL_CARRIER: `${UPDATE_PATH}/additional-carrier`,
  CONTINUE_EXISTING: `${UPDATE_PATH}/:carrier/continue-existing`,
  FETCHING: `${UPDATE_PATH}/fetching`,
  CARRIER_UNAVAILABLE: `${UPDATE_PATH}/[carrierSlug]/unavailable`,
  CARRIER_CONNECTED: `${UPDATE_PATH}/[carrierSlug]/connected`,
  BEAGLE_OFFER: `${SUBMISSION_ROOT_PATH}/beagle-offer`,
  BEAGLE_THANKS: `${SUBMISSION_ROOT_PATH}/beagle-thanks`,
  BEAGLE_PROPERTY_MANAGER: `${SUBMISSION_ROOT_PATH}/beagle-property-manager`,
};

export const ActiveValidationStorageKey = 'validationId';
